import { type PropsWithChildren, memo } from "react";

import { Icon } from "@react/components/Icon";
import { Text } from "@react/components/Text";
import { tw } from "classnames";

type Props = {
  handleCloseDrawer: () => void;
  type?: "bone" | "white";
};

const styles = {
  drawerHeader: (type: NonNullable<Props["type"]>) =>
    tw(
      "relative",
      "flex",
      "border-0",
      "border-b",
      "border-solid",
      "border-divider",
      {
        "bg-background-primary": type === "bone",
        "bg-white": type === "white",
      },
      "py-3",
      "pl-4",
      "pr-4"
    ),
  drawerHeaderBackButton: tw(
    "absolute",
    "top-2",
    "bg-transparent",
    "border-0",
    "outline-none",
    "h-8"
  ),
  drawerHeaderArrowIcon: tw("rotate-180", "w-8", "h-8"),
  drawerHeading: tw("flex-1", "text-center"),
};

const CartHeaderBase = ({
  children,
  handleCloseDrawer,
  type = "bone",
}: PropsWithChildren<Props>) => {
  return (
    <div className={styles.drawerHeader(type)}>
      <button
        className={styles.drawerHeaderBackButton}
        onClick={handleCloseDrawer}
      >
        <Icon className={styles.drawerHeaderArrowIcon} name="caret" />
      </button>
      <Text
        className={styles.drawerHeading}
        leading="relaxed"
        size={{ sm: "md" }}
      >
        {children}
      </Text>
    </div>
  );
};

export const CartHeader = memo(CartHeaderBase);
